import React from 'react';
interface OnboardingLayoutProps {
  children: ReactNode;
}
export const OnboardingLayout = ({
  children
}: OnboardingLayoutProps) => {
  return <div className="w-full min-h-screen bg-gray-100" data-id="element-485">
      <div className="max-w-4xl mx-auto bg-white min-h-screen" data-id="element-486">
        <div className="px-4 py-6" data-id="element-487">{children}</div>
      </div>
    </div>;
};